import { useSelector, shallowEqual } from 'react-redux';

import useActionCreator from '../../hooks/useActionCreator';
import { setStatus, setView, selectImage, getImages, updateImage, generateDescription } from './actions';

export const useGallery = () => {
  const galleryState = useSelector((state) => state.gallery, shallowEqual);

  return {
    ...galleryState,
    setStatus: useActionCreator(setStatus),
    setView: useActionCreator(setView),
    selectImage: useActionCreator(selectImage),
    getImages: useActionCreator(getImages),
    updateImage: useActionCreator(updateImage),
    generateDescription: useActionCreator(generateDescription),
  };
};
